import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebaseConfig'; 
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import * as Icons from 'react-icons/fa'; 
import { FaChevronDown } from 'react-icons/fa'; 
import * as SiIcons from 'react-icons/si';
import { socialConfig } from "./socialConfig";
const TopMenu = () => {
	const iconColors = {
  FaFacebookF: "#1877F2",
  FaFacebook: "#1877F2",

  SiYoutube: "#FF0000",
  FaYoutube: "#FF0000",

  FaInstagram: "#E4405F",
  SiInstagram: "#E4405F",

  FaWhatsapp: "#25D366",
  SiWhatsapp: "#25D366",

  FaTelegram: "#26A5E4",
  SiTelegram: "#26A5E4",

  FaXTwitter: "#000000",
  FaTwitter: "#1DA1F2",

  SiTiktok: "#000000",
  FaTiktok: "#000000",

  SiLinkedin: "#0A66C2",
  FaLinkedin: "#0A66C2",

  SiPinterest: "#E60023",
  FaPinterest: "#E60023",

  SiSnapchat: "#FFFC00",
  FaSnapchat: "#FFFC00",

  SiDiscord: "#5865F2",
  FaDiscord: "#5865F2",

  SiThreads: "#000000",

  SiX: "#000000",
};
  const [menuItems, setMenuItems] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const fetchMenuAndSocials = async () => {
      try {
        const menuQuery = query(collection(db, "topMenu"), orderBy("order", "asc"));
        const menuSnapshot = await getDocs(menuQuery);
        setMenuItems(menuSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

        const socialSnapshot = await getDocs(collection(db, "socialLinks"));
        setSocialLinks(socialSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error("ডেটা লোড করতে সমস্যা হয়েছে: ", error);
      }
    };
    fetchMenuAndSocials();
  }, []);

useEffect(() => {
  const handleClickOutside = () => setIsDropdownOpen(false);

  document.addEventListener("click", handleClickOutside);

  return () =>
    document.removeEventListener("click", handleClickOutside);
}, []);

const groupedSocials = socialLinks.reduce((acc, item) => {
  if (!acc[item.category]) acc[item.category] = [];
  acc[item.category].push(item);
  return acc;
}, {});

  return (
    <nav style={{ display: 'flex', gap: '20px', alignItems: 'center', position: 'relative' }}>
      {menuItems.map((item) => {
        const IconComponent = Icons[item.iconNam]; 
        
        // সোশ্যাল মিডিয়া মেনুর জন্য ড্রপডাউন এবং ক্লিক লজিক
        if (item.name === 'সোশ্যাল মিডিয়া' || item.name.toLowerCase() === 'social media') {
          return (
            <div
  key={item.id}
  style={{ position: 'relative', cursor: 'pointer' }}
  onMouseEnter={() => setIsDropdownOpen(true)}
  onMouseLeave={() => setIsDropdownOpen(false)}
  onClick={() => setIsDropdownOpen(prev => !prev)}
>
              <div style={{
                color: '#000000', 
                fontSize: '18px', 
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                paddingBottom: '2px'
              }}>
                {IconComponent && <IconComponent />}
                {item.name}
                <FaChevronDown style={{ fontSize: '12px', marginLeft: '2px' }} />
              </div>

              {isDropdownOpen && (
               <div
  style={{
  position: 'fixed',
top: '50px',     
left: '50%',
transform: 'translateX(-50%)',
width: '1000px',
maxWidth: '92vw',
	color: '#000000',
    backgroundColor: '#ffffff',
    boxShadow: '0 8px 20px rgba(0,0,0,.15)',
    borderRadius: '8px',
    padding: '15px',
    zIndex: 1000,
  }}
>
                {Object.keys(groupedSocials).length > 0 ? (
  Object.entries(groupedSocials).map(([category, links]) => (
    <div
      key={category}
      style={{
        border: '1px solid #e5e5e5',
        borderRadius: '8px',
        overflow: 'hidden',
        background: '#fff'
      }}
    >
      <div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 12px',
    background: '#fafafa',
    borderBottom: '1px solid #e5e5e5',
    fontWeight: '700',
    fontSize: '17px'
  }}
>
  <span
    style={{
      width: '4px',
      height: '18px',
      background: '#d2202a',
      borderRadius: '2px'
    }}
  />
  {category}
</div>


<div
  style={{
    display: 'grid',
	fontSize: '15px',
color: '#000000',
    gridTemplateColumns: 'repeat(3, minmax(180px, 1fr))',
    gap: '10px'
  }}
>
      {links.map((social) => {
      const config =
  socialConfig[(social.category || "").trim()] ||
  socialConfig["অন্যান্য"];

const SocialIcon = config.icon;

        return (
          <a
            key={social.id}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '10px 12px',
              textDecoration: 'none',
              color: '#333',
              borderBottom: '1px solid #f1f1f1'
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = '#f8f8f8')
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = '#fff')
            }
          >
            <SocialIcon
              style={{
                color: config.color,
                fontSize: '14px'
              }}
            />
            {social.name}
          </a>
        );
      })}
    </div>
	</div>
  ))
) : (
  <span style={{ padding: '10px' }}>কোনো লিংক নেই</span>
)}
   </div>
            )}
          </div>
        );
      }

      
        return (
          <Link 
            key={item.id} 
            to={item.url} 
            style={{ 
              textDecoration: 'none', 
              color: '#333333', 
              fontSize: '18px', 
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingBottom: '2px', 
              borderBottom: '2px solid transparent', 
              transition: '0.3s' 
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.color = '#d2202a';
              e.currentTarget.style.borderBottom = '2px solid #d2202a';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.color = '#333333';
              e.currentTarget.style.borderBottom = '2px solid transparent';
            }}
          >
            {IconComponent && <IconComponent />}
            {item.name}
          </Link>
        );
      })}
    </nav>
  );
};

export default TopMenu;